import axios from "axios";
import {
  loadDevelopmentMicrofrontends,
  getDevelopmentConfiguration,
  getDevelopmentRoutes,
} from "../../helpers/developmentRoutes";

import type { DRSConfiguration, DRSRoute, ImportMap } from "../../types/drs";
import { isRoutePublic } from "../../helpers/publicRoutes";
import { getAuthorizationInterface } from "../../static/authorization";

const developmentMicrofrontends = loadDevelopmentMicrofrontends();

export const fetchData = async (path: string) => {
  try {
    const headers: any = {};
    const jwtToken = getAuthorizationInterface().getJwt();

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }

    const response = await axios.get(`${process.env.GUAC_DRS_URL}${path}`, {
      headers,
    });

    return response.data;
  } catch {
    return [];
  }
};

export const getRoutes = async (): Promise<DRSRoute[]> => {
  const path = isRoutePublic() ? "/public/routes" : "/routes";
  const routes: DRSRoute[] = await fetchData(path);

  const developmentRoutes = getDevelopmentRoutes(developmentMicrofrontends);

  return [...routes, ...developmentRoutes];
};

export const getConfiguration = async (): Promise<DRSConfiguration> => {
  const configuration: DRSConfiguration = await fetchData("/public/configuration");

  const developmentConfiguration = getDevelopmentConfiguration(developmentMicrofrontends);

  return {
    applications: [...configuration.applications, ...developmentConfiguration.applications],
  };
};

export const getImportMap = async (): Promise<ImportMap> => {
  const importMap: ImportMap = await fetchData("/public/import_map");

  return importMap;
};
